export function DiamondIcon(props: Readonly<React.SVGProps<SVGSVGElement>>) {
  return (
    <svg
      fill="none"
      height={25}
      viewBox="0 0 24 25"
      width={24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.408 10.44l-9.972 9.984a2.036 2.036 0 01-2.85.03L9.9 19.8l-.092-.086-2.728-2.615-.092-.086-2.756-2.643-.064-.06-2.812-2.699-.03-.03-.7-.669a2.039 2.039 0 01-.11-2.828l3.486-3.902a2.04 2.04 0 011.52-.682h12.982a2.028 2.028 0 011.412.568c.01.012.022.02.03.031l2.64 2.643.089.088.73.732a2.042 2.042 0 010 2.882l.002-.003z"
        fill="#FAFAFA"
      />
      <path
        d="M19.917 4.068L7.084 17.096l-.092-.086-2.756-2.643-.064-.06L14.82 3.5h3.688a2.028 2.028 0 011.412.568h-.003z"
        fill="#C4C4C4"
      />
      <path
        d="M19.917 4.068L7.084 17.096l-.092-.086-2.756-2.643-.064-.06L14.82 3.5h3.688a2.028 2.028 0 011.412.568h-.003z"
        fill="url(#paint0_linear_2423_63768)"
      />
      <path
        d="M14.944 3.5L4.236 14.37l-.064-.06-2.812-2.699-.033-.03L9.29 3.5h5.655z"
        fill="#C4C4C4"
      />
      <path
        d="M14.944 3.5L4.236 14.37l-.064-.06-2.812-2.699-.033-.03L9.29 3.5h5.655z"
        fill="#24E0E0"
      />
      <path
        d="M9.35 3.5l-7.989 8.111-.03-.03-.7-.669a2.039 2.039 0 01-.11-2.828l3.483-3.902a2.04 2.04 0 011.52-.682H9.35z"
        fill="#C4C4C4"
      />
      <path
        d="M9.35 3.5l-7.989 8.111-.03-.03-.7-.669a2.039 2.039 0 01-.11-2.828l3.483-3.902a2.04 2.04 0 011.52-.682H9.35z"
        fill="#3DF9F9"
      />
      <path
        d="M22.675 6.83L9.9 19.798l-.092-.086-2.728-2.615-.092-.086L19.822 3.984c.03.025.063.053.094.084.011.01.022.019.03.03l2.64 2.643.09.088z"
        fill="#C4C4C4"
      />
      <path
        d="M22.675 6.83L9.9 19.798l-.092-.086-2.728-2.615-.092-.086L19.822 3.984c.03.025.063.053.094.084.011.01.022.019.03.03l2.64 2.643.09.088z"
        fill="url(#paint1_linear_2423_63768)"
      />
      <path
        d="M23.407 10.441l-9.971 9.983a2.036 2.036 0 01-2.851.03L9.9 19.8l-.091-.086L22.587 6.742l.088.089.73.732a2.042 2.042 0 010 2.881l.002-.003z"
        fill="url(#paint2_linear_2423_63768)"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_2423_63768"
          x1={4.171_88}
          x2={19.9169}
          y1={10.2994}
          y2={10.2994}
        >
          <stop stopColor="#1BB9DD" />
          <stop offset={1} stopColor="#0EC3CC" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_2423_63768"
          x1={14.8331}
          x2={14.8331}
          y1={19.7987}
          y2={3.984_38}
        >
          <stop stopColor="#E24BEA" />
          <stop offset={1} stopColor="#FFA9F9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_2423_63768"
          x1={16.9074}
          x2={16.9074}
          y1={21.0231}
          y2={6.742_19}
        >
          <stop stopColor="#E561DC" />
          <stop offset={1} stopColor="#FFA9F9" />
        </linearGradient>
      </defs>
    </svg>
  )
}
